import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, toDisplayString as _toDisplayString, createElementBlock as _createElementBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "container-fluid" }
const _hoisted_2 = { class: "container" }
const _hoisted_3 = { name: "form" }
const _hoisted_4 = { class: "contain row" }
const _hoisted_5 = {
  key: 1,
  class: "page-container card col-md-8"
}
const _hoisted_6 = {
  key: 0,
  class: "row"
}
const _hoisted_7 = { class: "col-md-12 p-4" }
const _hoisted_8 = { class: "row mb-3" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Month:")
], -1)
const _hoisted_10 = { class: "col-md-6" }
const _hoisted_11 = { class: "row mb-3" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("b", null, "Exchange Rate", -1)
const _hoisted_13 = { class: "row mb-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Currency:")
], -1)
const _hoisted_15 = { class: "col-md-6" }
const _hoisted_16 = {
  key: 0,
  class: "d-flex align-items-center"
}
const _hoisted_17 = { class: "col-md-3" }
const _hoisted_18 = { class: "col-md-9" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "d-flex align-items-center col-md-12" }
const _hoisted_21 = { class: "col-md-3" }
const _hoisted_22 = { class: "col-md-9" }
const _hoisted_23 = { class: "row" }
const _hoisted_24 = { class: "col-md-6" }
const _hoisted_25 = { class: "row mb-3" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Closing Rate:")
], -1)
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "row mb-3" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6 required" }, [
  /*#__PURE__*/_createElementVNode("label", { class: "col-form-label-title" }, "Average Rate:")
], -1)
const _hoisted_30 = { class: "col-md-6" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-6" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "col-form-info-title" }, "The exchange rate is based on the MYR currency."),
  /*#__PURE__*/_createElementVNode("br"),
  /*#__PURE__*/_createElementVNode("span", { class: "col-form-info-title" }, "Example: "),
  /*#__PURE__*/_createElementVNode("ul", { class: "pl-2 ml-2 mt-0 col-form-info" }, [
    /*#__PURE__*/_createElementVNode("li", null, "1 USD = 4.700000 MYR (Please key in \"4.700000\" as the exchange rate)"),
    /*#__PURE__*/_createElementVNode("li", null, "1 CNY = 0.649234 MYR (Please key in \"0.649234\" as the exchange rate)")
  ])
], -1)
const _hoisted_32 = { class: "row mb-3" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-3" }, null, -1)
const _hoisted_34 = { class: "d-flex col-md-6" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("span", { class: "p-1" }, null, -1)
const _hoisted_36 = { class: "row mb-3" }
const _hoisted_37 = { class: "col-md-12 pt-4" }
const _hoisted_38 = { class: "error-no-record mt-3" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("h6", null, [
  /*#__PURE__*/_createElementVNode("span", null, "No Record Found")
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TheHeader = _resolveComponent("TheHeader")!
  const _component_TheSidebar = _resolveComponent("TheSidebar")!
  const _component_ThePageLoading = _resolveComponent("ThePageLoading")!
  const _component_ThePageHeader = _resolveComponent("ThePageHeader")!
  const _component_Calendar = _resolveComponent("Calendar")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Dropdown = _resolveComponent("Dropdown")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!
  const _component_TheLoading = _resolveComponent("TheLoading")!
  const _component_TheTableLoading = _resolveComponent("TheTableLoading")!
  const _component_Column = _resolveComponent("Column")!
  const _component_FontAwesomeIcon = _resolveComponent("FontAwesomeIcon")!
  const _component_DataTable = _resolveComponent("DataTable")!
  const _component_ThePageError = _resolveComponent("ThePageError")!
  const _component_TheFooter = _resolveComponent("TheFooter")!
  const _component_TheInvalidImportDialog = _resolveComponent("TheInvalidImportDialog")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_TheHeader),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("form", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_TheSidebar),
            (_ctx.isPageLoading)
              ? (_openBlock(), _createBlock(_component_ThePageLoading, { key: 0 }))
              : _createCommentVNode("", true),
            (!_ctx.isPageLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_component_ThePageHeader, {
                    onImportEvent: _ctx.importFile,
                    onExportEvent: _ctx.exportFile,
                    renderImport: !_ctx.isLoading,
                    renderExport: !_ctx.isLoading,
                    isImporting: _ctx.isImporting,
                    isExporting: _ctx.isExporting
                  }, null, 8, ["onImportEvent", "onExportEvent", "renderImport", "renderExport", "isImporting", "isExporting"]),
                  (_ctx.pageError == '')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                        _createElementVNode("div", _hoisted_7, [
                          _createElementVNode("div", _hoisted_8, [
                            _hoisted_9,
                            _createElementVNode("div", _hoisted_10, [
                              _createVNode(_component_Calendar, {
                                modelValue: _ctx.date,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.date) = $event)),
                                view: "month",
                                dateFormat: "M yy",
                                showIcon: ""
                              }, null, 8, ["modelValue"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_11, [
                            _createVNode(_component_Divider, null, {
                              default: _withCtx(() => [
                                _hoisted_12
                              ]),
                              _: 1
                            })
                          ]),
                          _createElementVNode("div", _hoisted_13, [
                            _hoisted_14,
                            _createElementVNode("div", _hoisted_15, [
                              _createVNode(_component_Dropdown, {
                                options: _ctx.currencies,
                                optionLabel: "code",
                                optionValue: "identifier",
                                filter: "",
                                filterFields: ['code', 'name'],
                                showClear: "",
                                placeholder: "-- Please Select --",
                                modelValue: _ctx.currencyExchangeRate.currency.identifier,
                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.currencyExchangeRate.currency.identifier) = $event)),
                                disabled: _ctx.date == null,
                                onChange: _ctx.onChangeCurrency
                              }, {
                                value: _withCtx((slotProps) => [
                                  (slotProps.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                        _createElementVNode("span", _hoisted_17, _toDisplayString(_ctx.filterCurrencyCodeByValue(slotProps.value)), 1),
                                        _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.filterCurrencyNameByValue(slotProps.value)), 1)
                                      ]))
                                    : (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(slotProps.placeholder), 1))
                                ]),
                                option: _withCtx((slotProps) => [
                                  _createElementVNode("div", _hoisted_20, [
                                    _createElementVNode("span", _hoisted_21, _toDisplayString(slotProps.option.code), 1),
                                    _createElementVNode("span", _hoisted_22, _toDisplayString(slotProps.option.name), 1)
                                  ])
                                ]),
                                _: 1
                              }, 8, ["options", "modelValue", "disabled", "onChange"])
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_23, [
                            _createElementVNode("div", _hoisted_24, [
                              _createElementVNode("div", _hoisted_25, [
                                _hoisted_26,
                                _createElementVNode("div", _hoisted_27, [
                                  _createVNode(_component_InputNumber, {
                                    class: "p-inputnumber",
                                    placeholder: "Closing Rate",
                                    modelValue: _ctx.currencyExchangeRate.closingExchangeRate,
                                    "onUpdate:modelValue": [
                                      _cache[2] || (_cache[2] = ($event: any) => ((_ctx.currencyExchangeRate.closingExchangeRate) = $event)),
                                      _ctx.setDefaultAverageExchangeRate
                                    ],
                                    minFractionDigits: 6,
                                    maxFractionDigits: 6,
                                    disabled: _ctx.date == null
                                  }, null, 8, ["modelValue", "disabled", "onUpdate:modelValue"])
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_28, [
                                _hoisted_29,
                                _createElementVNode("div", _hoisted_30, [
                                  _createVNode(_component_InputNumber, {
                                    class: "p-inputnumber",
                                    placeholder: "Average Rate",
                                    modelValue: _ctx.currencyExchangeRate.averageExchangeRate,
                                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.currencyExchangeRate.averageExchangeRate) = $event)),
                                    minFractionDigits: 6,
                                    maxFractionDigits: 6,
                                    disabled: _ctx.date == null
                                  }, null, 8, ["modelValue", "disabled"])
                                ])
                              ])
                            ]),
                            _hoisted_31
                          ]),
                          _createElementVNode("div", _hoisted_32, [
                            _hoisted_33,
                            _createElementVNode("div", _hoisted_34, [
                              _createVNode(_component_Button, {
                                class: "p-button-sm",
                                disabled: _ctx.v$.currencyExchangeRate.$invalid || _ctx.isLoading && _ctx.date == null,
                                onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.currencyExchangeRate.identifier == null ? _ctx.save() : _ctx.update())),
                                label: "Save"
                              }, null, 8, ["disabled"]),
                              _hoisted_35,
                              _createVNode(_component_Button, {
                                class: "p-button-sm p-button-secondary",
                                onClick: _ctx.reset,
                                label: "Reset"
                              }, null, 8, ["onClick"]),
                              (_ctx.isLoading)
                                ? (_openBlock(), _createBlock(_component_TheLoading, { key: 0 }))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("div", _hoisted_37, [
                              (_ctx.isExchangeRateTableLoading)
                                ? (_openBlock(), _createBlock(_component_TheTableLoading, { key: 0 }))
                                : _createCommentVNode("", true),
                              (!_ctx.isExchangeRateTableLoading)
                                ? (_openBlock(), _createBlock(_component_DataTable, {
                                    key: 1,
                                    value: _ctx.currencyExchangeRates,
                                    class: "exchangeRateTable",
                                    onRowClick: _ctx.selectCurrencyRate
                                  }, {
                                    empty: _withCtx(() => [
                                      _createElementVNode("div", _hoisted_38, [
                                        _createVNode(_component_FontAwesomeIcon, {
                                          icon: ['fas', 'image'],
                                          size: "2x"
                                        }),
                                        _hoisted_39
                                      ])
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_Column, {
                                        style: {"width":"15%"},
                                        field: "currency.code",
                                        header: "Code"
                                      }),
                                      _createVNode(_component_Column, {
                                        style: {"width":"45%"},
                                        field: "currency.name",
                                        header: "Name"
                                      }),
                                      _createVNode(_component_Column, {
                                        style: {"width":"15%"},
                                        field: "closingExchangeRate",
                                        header: "Closing Rate"
                                      }),
                                      _createVNode(_component_Column, {
                                        style: {"width":"15%"},
                                        field: "averageExchangeRate",
                                        header: "Average Rate"
                                      }),
                                      _createVNode(_component_Column, {
                                        style: {"width":"10%"},
                                        header: ""
                                      }, {
                                        body: _withCtx((slotProps) => [
                                          _createVNode(_component_Button, {
                                            icon: "pi pi-trash",
                                            severity: "danger",
                                            text: "",
                                            rounded: "",
                                            onClick: ($event: any) => (_ctx.deleteExchangeRate(slotProps.data)),
                                            title: "Delete"
                                          }, null, 8, ["onClick"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _: 1
                                  }, 8, ["value", "onRowClick"]))
                                : _createCommentVNode("", true)
                            ])
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.pageError != '')
                    ? (_openBlock(), _createBlock(_component_ThePageError, {
                        key: 1,
                        onBackEvent: _ctx.cancel,
                        pageError: _ctx.pageError
                      }, null, 8, ["onBackEvent", "pageError"]))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true),
            _createVNode(_component_TheFooter)
          ])
        ])
      ])
    ]),
    _createVNode(_component_TheInvalidImportDialog, {
      title: "Currency Exchange Rate",
      visible: _ctx.isDialogVisible,
      data: _ctx.invalidData,
      onCloseDialogEvent: _ctx.closeDialog,
      onProceedImportEvent: _ctx.proceedImport
    }, null, 8, ["visible", "data", "onCloseDialogEvent", "onProceedImportEvent"])
  ], 64))
}